"use strict";

( function( namespace ) {
	var autoPlayCount = 1;

	/**
	* Get referrer domain.
	*/
	var getRefDomain = function() {
		var refdomain, network, networks = {
			social_facebook_inapp: { ua: "FB" },
			social_facebook: {
				ref: "facebook\\.com",
				query: "spr_fb",
			},
			social_google: {
				ref: "(plus|plus\\.url)\\.google\\.com",
				ua: "GooglePlus",
			},
			social_pinterest: {
				ref: "pinterest\\.com",
				ua: "Pinterest",
			},
			social_twitter_ios_app: { ua: "Twitter for iPhone" },
			social_twitter: {
				ref: "t\\.co",
				query: "spr_tw",
				ua: "Twitter",
			},
		};

		for ( network in networks ) {
			// Check user agent
			if ( networks[ network ].ua ) {
				var regUser = new RegExp( networks[ network ].ua, "i" );
				if ( navigator.userAgent.match( regUser ) ) {
					refdomain = network;
					break;
				}
			}

			// Check referring domain
			if ( networks[ network ].ref ) {
				var regRefer = new RegExp( networks[ network ].ref, "i" );
				if ( document.referrer.match( regRefer ) ) {
					refdomain = network;
					break;
				}
			}

			// Check query parameters
			if ( networks[ network ].query ) {
				var regQuery = new RegExp( networks[ network ].query, "i" );
				if ( document.location.search.match( regQuery ) ) {
					refdomain = network;
					break;
				}
			}
		}

		if ( typeof ( refdomain ) == "undefined" ) {
			refdomain = "";
		}

		return refdomain;
	};

	/**
	 * Get OS and Browser in the format <OS>-<OS version>_<browser>-<browser version>.
	 */
	var getOsAndBrowser = function() {
		var result = window.uaParser( window.navigator.userAgent );
		var osb = result.browser.name + "-" + result.browser.version + "_" + result.os.name + "-" + result.os.version;

		return osb.toLowerCase().replace( / /g, "" );
	};

	/**
	* Get additional KV params.
	*/
	var getAdditionalKVParams = function() {
		var additionalKVs = [];

		if ( window.HRST.article && window.HRST.article.section ) {
			var section = window.HRST.article.section.prefix;
			additionalKVs.push( "sect=" + section.replace( /-/g, "_" ) );
		}

		if ( window.HRST.article && window.HRST.article.subSection ) {
			var subsection = window.HRST.article.subSection.prefix;
			additionalKVs.push( "sub=" + subsection.replace( /-/g, "_" ) );
		}

		if ( window.HRST.article && window.HRST.article.collections ) {
			var collections = window.HRST.article.collections;
			additionalKVs.push( "clc=" + collections.replace( /-/g, "_" ) );
		}

		return additionalKVs.length > 0 ? additionalKVs.join( "&" ) : "";
	};

	/**
	* Get custom params.
	*/
	var getCustomParams = function( el, player ) {
		var customParams = [];

		var additionalKVParams = getAdditionalKVParams();
		if ( additionalKVParams ) {
			customParams.push( additionalKVParams );
		}

		customParams.push( "tool=video" );
		customParams.push( "pos=8" );

		if ( window.HRST.article ) {
			customParams.push( "artid=" + window.HRST.article.artID );
		}

		var adSlot = autoPlayCount;
		if ( player.playlist.currentIndex === 0 ) {
			autoPlayCount++;
		} else {
			adSlot = "recommended";
		}
		customParams.push( "adslot=" + adSlot );

		customParams.push( "refdomain=" + getRefDomain() );

		if ( window.HRST.article ) {
			customParams.push( "pageUrl=" + window.HRST.article.pageUrl );
		}

		if ( window.HRST.site ) {
			customParams.push( "site=" + window.HRST.site.name );
		}

		if ( window.dataMapping ) {
			customParams.push( "urlHash=" + window.dataMapping.urlHash );
		}

		if ( window.LUMIERE_CUSTOM_TOKEN ) {
			customParams.push( "token=" + window.LUMIERE_CUSTOM_TOKEN );
		}

		customParams.push( "videoID=" + player.playlist.sources[ 0 ].id );
		customParams.push( "embedID=" + el.getAttribute( "data-player-id" ) );

		if ( player.currentWidth() > 0 && player.currentHeight() > 0 ) {
			customParams.push( "width=" + Math.floor( player.currentWidth() ) );
			customParams.push( "height=" + Math.floor( player.currentHeight() ) );
		}

		customParams.push( "vid_t=" + player.playlist.sources[ 0 ].title );

		customParams.push( "osb=" + getOsAndBrowser() );

		if ( window.LUMIERE_PLATFORM ) {
			customParams.push( "pltfrm=" + window.LUMIERE_PLATFORM );
		}

		var ad_request_id = Math.random().toString( 36 ).substring( 2, 15 ) +
			Math.random().toString( 36 ).substring( 2, 15 );
		customParams.push( "ad_request_id=" + ad_request_id );

		return customParams.length > 0 ? customParams.join( "&" ) : "";
	};

	/**
	* Get player dimensions.
	*/
	var getPlayerDimensions = function() {
		return "640x480";
	};

	/**
	* Get Ad Tag URL.
	*/
	namespace.getAdTagUrl = function( el, player, bid ) {
		var params = {
			gdfp_req: 1,
			env: "vp",
			impl: "s",
			unviewed_position_start: 1,
			output: "xml_vast3",
			sz: getPlayerDimensions() + "|3x3",
			iu: "/" + window.HRST.site.dartZone + "/" + window.HRST.site.adUnit,
			url: encodeURIComponent( window.HRST.article.pageUrl ),
			ciu_szs: ismobilejs.phone ? "320x50,300x250" : "300x250,728x90",
			description_url: encodeURIComponent( window.HRST.article.pageUrl ),
			vpos: "preroll",
			cust_params: encodeURIComponent( getCustomParams( el, player ) ),
		};

		if ( bid ) {
			params.scp = bid;
		}

		var adTagUrl = "https://pubads.g.doubleclick.net/gampad/ads?" + Object.keys( params ).map( function( key ) {
			return [
				key,
				params[ key ],
			].join( "=" );
		} ).join( "&" );

		videojs.log( player.id() + " adTagUrl = " + adTagUrl );

		return adTagUrl;
	};

	/**
	* Request Amazon video bid.
	*/
	namespace.requestAmazonBid = function( el, player, callback, slotID ) {
		if ( !window.apstag ) {
			videojs.log( player.id() + " A9 not ready" );
			callback( el, player );
			return;
		}

		var slots = [];
		slots.push( {
			slotID: slotID,
			mediaType: "video",
		} );

		videojs.log( player.id() + " A9 fetching bids" );

		window.apstag.fetchBids( {
			slots: slots,
			timeout: 2000,
		}, function( bids ) {
			videojs.log( player.id() + " A9 got bids: " + bids.length );

			if ( bids.length > 0 && bids[ 0 ].encodedQsParams ) {
				var scp = bids[ 0 ].encodedQsParams.substring( 3, bids[ 0 ].encodedQsParams.length );
				callback( el, player, scp );
			} else {
				callback( el, player );
			}
		} );
	};
} )( window.hearstLumierePlayer = window.hearstLumierePlayer || /* istanbul ignore next */ {} );



//////////////////
// WEBPACK FOOTER
// ./src/ads.js
// module id = 88
// module chunks = 0